module.exports = __webpack_public_path__ + "img/circulito.b3df4463.svg";